var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('testimonial-template',{attrs:{"testimonials":_vm.testimonials,"fullWidthColor":true}})}
var staticRenderFns = []

export { render, staticRenderFns }